export const cubeList = [
    {
        label: "H-W-D",
        id: "H-W-D",
        pattern: "H-W-D",
        image: {
            url: "/images/box/hwd.png",
        },
    },
    {
        label: "W-H-D",
        id: "W-H-D",
        pattern: "W-H-D",
        image: {
            url: "/images/box/whd.png",
        },
    },
    {
        label: "D-H-W",
        id: "D-H-W",
        pattern: "D-H-W",
        image: {
            url: "/images/box/dhw.png",
        },
    },
    {
        label: "D-W-H",
        id: "D-W-H",
        pattern: "D-W-H",
        image: {
            url: "/images/box/dwh.png",
        },
    },
    {
        label: "H-D-W",
        id: "H-D-W",
        pattern: "H-D-W",
        image: {
            url: "/images/box/hdw.png",
        },
    },
    {
        label: "W-D-H",
        id: "W-D-H",
        pattern: "W-D-H",
        image: {
            url: "/images/box/wdh.png",
        },
    },
];
